'use strict';

var CALENDAR_EVENT_DURATION_MS = 60 * 60 * 1000;

function toICSDate (timestamp) {
    return new Date(timestamp)
        .toISOString()
        .replace(/[-:]/g, '')
        .replace(/\.\d{3}Z$/, 'Z');
}

function escapeICSText (value) {
    return String(value || '')
        .replace(/\\/g, '\\\\')
        .replace(/\n/g, '\\n')
        .replace(/,/g, '\\,')
        .replace(/;/g, '\\;');
}

function createCalendarICS (opts) {
    var title = escapeICSText(opts.title || 'Live Shopping');
    var details = escapeICSText(opts.details || '');
    var showId = String(opts.showId || 'event').replace(/[^a-zA-Z0-9_-]/g, '') || 'event';
    var startAt = opts.startAt;
    var endAt = opts.endAt || (startAt + CALENDAR_EVENT_DURATION_MS);

    return {
        fileName: 'live-shopping-' + showId + '.ics',
        content: [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'PRODID:-//Intimissimi//Live Shopping//EN',
            'BEGIN:VEVENT',
            'UID:' + showId + '-' + startAt + '-live-shopping@intimissimi',
            'DTSTAMP:' + toICSDate(Date.now()),
            'DTSTART:' + toICSDate(startAt),
            'DTEND:' + toICSDate(endAt),
            'SUMMARY:' + title,
            'DESCRIPTION:' + details,
            'END:VEVENT',
            'END:VCALENDAR',
        ].join('\r\n'),
    };
}

function downloadCalendarICS (opts) {
    if (typeof window === 'undefined') {
        return;
    }

    var ics = createCalendarICS(opts);
    var blob = new Blob([ics.content], { type: 'text/calendar;charset=utf-8' });
    var objectUrl = window.URL.createObjectURL(blob);
    var link = document.createElement('a');

    link.href = objectUrl;
    link.download = ics.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(objectUrl);
}

function parseStartTimestamp (raw) {
    if (!raw) {
        return null;
    }

    var num = Number(raw);
    if (!isNaN(num) && num > 0) {
        return num < 1e12 ? num * 1000 : num;
    }

    var parsed = Date.parse(raw);
    return isNaN(parsed) ? null : parsed;
}

function initCalendarButtons () {
    var buttons = document.querySelectorAll('.js-liveShoppingUpcomingCalendar');

    for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', function (e) {
            e.stopPropagation();

            var btn = e.currentTarget;
            var startAt = parseStartTimestamp(btn.getAttribute('data-start-at'));
            if (!startAt) {
                return;
            }

            downloadCalendarICS({
                title: btn.getAttribute('data-title') || 'Live Shopping',
                startAt: startAt,
                endAt: startAt + CALENDAR_EVENT_DURATION_MS,
                showId: btn.getAttribute('data-show-id') || '',
            });
        });
    }
}

module.exports = {
    CALENDAR_EVENT_DURATION_MS: CALENDAR_EVENT_DURATION_MS,
    createCalendarICS: createCalendarICS,
    downloadCalendarICS: downloadCalendarICS,
    initCalendarButtons: initCalendarButtons,
};
